import { useMemo, ReactNode } from 'react';

import { useProjectAccess } from '../hooks/useProjectAccess';
import { ProjectAccessContext } from './projectAccess';

interface ProjectAccessProviderProps {
  projectId?: string;
  children: ReactNode;
}

/**
 * Load the caller's effective access once per project and share it with the
 * whole project subtree, so gates no longer travel as props.
 *
 * @param projectId Project UUID. Access resets when it changes.
 */
export const ProjectAccessProvider = ({ projectId, children }: ProjectAccessProviderProps) => {
  const { access, loading, error, reloadAccess } = useProjectAccess(projectId);

  const value = useMemo(
    () => ({ access, loading, error, reloadAccess }),
    [access, loading, error, reloadAccess],
  );

  return <ProjectAccessContext.Provider value={value}>{children}</ProjectAccessContext.Provider>;
};

